module.exports = function rateLimit({
    windowMs = 60000,
    max = 100,
    message = 'Too many requests, please try again later.'
} = {}) {
    const hits = new Map();
    return (req, res, next) => {
        const ip = req.headers['x-forwarded-for'] || req.socket.remoteAddress || 'unknown';
        const now = Date.now();
        if (!hits.has(ip)) {
            hits.set(ip, { count: 1, resetTime: now + windowMs });
        } else {
            const record = hits.get(ip);
            if (now > record.resetTime) {
                record.count = 1;
                record.resetTime = now + windowMs;
            } else {
                record.count++;
                if (record.count > max) {
                    if (res.json) return res.json({ error: message }, 429);
                    res.writeHead(429, { 'Content-Type': 'application/json' });
                    return res.end(JSON.stringify({ error: message }));
                }
            }
        }
        next();
    };
};
